import type {
  TicketEventMentionMarkViewedApiData,
  TicketEventMentionMarkViewedApiResponses,
  TicketEventMentionsForMeListApiData,
  TicketEventMentionsForMeListApiResponses,
  TicketEventMentionsForMeMarkViewedApiData,
  TicketEventMentionsForMeMarkViewedApiResponses,
  TicketEventMentionsForMeUnreadCountApiData,
  TicketEventMentionsForMeUnreadCountApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getTicketEventMentionUrls = {
  getPaginatedMyTicketEventMentions: dataEndpoint<
    TicketEventMentionsForMeListApiData,
    TicketEventMentionsForMeListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('ticket-event-mentions/me/', queryParams)
  }),
  getMyTicketEventMentionsUnreadCount: dataEndpoint<
    TicketEventMentionsForMeUnreadCountApiData,
    TicketEventMentionsForMeUnreadCountApiResponses
  >({
    getUrl: () => apiUrl('ticket-event-mentions/me/unread-count/')
  }),
  postMarkMyTicketEventMentionsViewed: responseEndpoint<
    TicketEventMentionsForMeMarkViewedApiData,
    TicketEventMentionsForMeMarkViewedApiResponses
  >({
    getUrl: () => apiUrl('ticket-event-mentions/me/mark-viewed/'),
    getBody: (data) => data
  }),
  postMarkTicketEventMentionViewed: responseEndpoint<
    TicketEventMentionMarkViewedApiData,
    TicketEventMentionMarkViewedApiResponses
  >({
    getUrl: ({ ticketEventMentionId }) => apiUrl(`ticket-event-mentions/${ticketEventMentionId}/viewed/`)
  })
};
